import styled from 'styled-components';

import React, {useState, useEffect} from 'react';

import {
  Flex,
  Image,
  ImageWrapper,
} from '../../../components/common/StyledComponent/CommonStyledComponent';
import {getImageToBeRendered } from '../../../utility/utils.js';
import { postSupportClickEvent } from '../../../utility/common';

const SourceCard = styled.button`
  width: 100%;
  display: flex;
  align-items: flex-start;
  border-radius: 12px;
  padding: 16px;
  gap: 16px;
  border: none;
  background: #fff;
  text-align: left;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  cursor: pointer;

  /* button reset */
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
  font: inherit;
  color: inherit;
  transform-origin: center center;
  will-change: transform;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.06);
  transition: transform 280ms cubic-bezier(0.34, 1.56, 0.64, 1);

  &:hover {
    transform: scale(1.045);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 3px solid #000000;
    outline-offset: 2px;
    border-radius: 12px;
  }

  .source-card-content {
    min-width: 0;
  }
    .source-card-title{
     display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;       
    overflow: hidden;
    text-overflow: ellipsis;
    }

  @media (min-width: 768px) and (max-width: 1023px) {
    .source-card-title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .vds-micro {
    color: rgba(113, 111, 109, 1);
  }
`;

const AskAIAccordionSourceCard = ({citation, recordTitle, imageUrl,lmsImage, recordUrl, category, id }) => {
  if (recordUrl?.includes("super-bowl")) {
    return null; 
  } 
  const [newImageURL, setNewImageURL] = useState(null);
   const [useFallbackImage, setUseFallbackImage] = useState(false);

   // 2. Fetch the dynamic image
  useEffect(() => {
    let isCancelled = false;
    
    const loadImage = async () => {
      if (!id) return;
      
      try {
        const userlng = localStorage.getItem('lng') || 'en'; // Or fetch from Redux if you store it there
        
        const getMappedCategory = () => {
          const cat = (category || '').toLowerCase();
          
          if (cat.includes('person')) return "inPersonEvents"; 
          if (cat.includes('event')) return "events"; 
          if (cat.includes('course')) return "courses"; 
          if (cat.includes('tip')) return "quickTips"; 
          if (cat.includes('path')) return "learningpath"; 
          if (cat.includes('library')) return "myLibrary"; 
          if (cat.includes('instructor')) return "instructorProfile";
          if (cat.includes('skill')) return "skillimg";
          
          return "course_details"; 
        };

        const mappedCategory = getMappedCategory();
         const safeId = String(id).split(':').pop();
        
        const newUrl = await getImageToBeRendered(
          'ai_sources', 
          '', 
          mappedCategory, 
          userlng,
          safeId, 
          mappedCategory === 'quickTips' ? imageUrl : '', 
          '', 
          "typeAheadResImg"
        );
        if (!isCancelled) {
          const img = new window.Image();
          img.src = imageUrl;
          img.onload = () => {
            if (!isCancelled) {
              setNewImageURL(imageUrl);
              console.log('Image loaded successfully for item sourcecard:', id);
            }
          };
          img.onerror = () => {
            if (!isCancelled) 
              {
                setNewImageURL(imageUrl ?? lmsImage);
                console.log('Failed to load image for item sourcecard:', id, 'Using fallback image.');
              }
          };
        }
      } catch (error) {
        if (!isCancelled) {
          setNewImageURL(imageUrl ?? lmsImage);
          console.log('Error loading image for item sourcecard:', id, 'Using fallback image.', error);
        }
      }
    };

    setUseFallbackImage(false);
    loadImage();

    return () => {
      isCancelled = true;
    };
  }, [imageUrl, id]);

  const handleCardClick = (citation) => {
    if (recordUrl) {
      let gid = localStorage?.getItem('gptGlobalID');
      postSupportClickEvent(gid,citation?.eventSerpName);
      window.open(recordUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <SourceCard type='button' onClick={() => handleCardClick(citation)}>
      <ImageWrapper
        width="68px"
        height="68px"
        borderRadius="8px"
        overflow="hidden"
        minWidth="68px"
        minHeight="68px"
        maxWidth="68px"
        maxHeight="68px"
      >
        <Image
          src={useFallbackImage ? (citation?.lmsImage ?? '') : (newImageURL ? newImageURL : imageUrl)}
          onError={() => {
            if (!useFallbackImage && citation?.lmsImage) {
              setUseFallbackImage(true);
            }
          }}
        />
      </ImageWrapper>
      <Flex className='source-card-content' flexDirection="column" gap="4px">
        <div className="vds-micro font-eTX-bold">{category}</div>
        <div className="vds-title-xs mobile-vds-title-2xs source-card-title">{recordTitle}</div>
      </Flex>
    </SourceCard>
  );
};

export default AskAIAccordionSourceCard;
